import { Comment } from "../../models/Comment";
import "../../styles/comments/commentList.css";
import { CommentEditor } from "./CommentEditor";

export { CommentList };

type Props = {
  /**
   * List of Comments to render
   */
  comments: Comment[];

  /**
   * True if a new CommentEditor should be displayed.
   */
  newComment: boolean;
  /**
   * When a comment has been created or edited.
   */
  onChange: (comments: Comment[]) => void;
};

const CommentList = (props: Props) => {
  return (
    <div className={"commentList"}>
      {props.newComment && (
        <CommentEditor
          comment={undefined}
          onCommentEdit={(x) =>
            props.onChange(
              [
                {
                  lastModified: undefined,
                  created: undefined,
                  author: "",
                  comment: x,
                } as Comment,
              ].concat(props.comments),
            )
          }
        />
      )}
      {props.comments.map((com, i) => (
        <CommentEditor
          key={`${com.created}-${i}-${com.comment}`}
          comment={com}
          onCommentEdit={(x) => {
            com.comment = x;
            props.onChange(props.comments);
          }}
        />
      ))}
      {!props.newComment && props.comments.length === 0 && (
        <span>Template has no notes</span>
      )}
    </div>
  );
};
